<mat-table
  #datatable
  class="datatable__table"
  [dataSource]="locations"
  fusePerfectScrollbar
  matSort
  [matSortDisableClear]="true"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="35">
      {{ 'LOCATIONS.HEADER.NAME' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let location" fxFlex="35" fxFlex.xs="100">
      <span class="mobile-label">{{ 'LOCATIONS.HEADER.NAME' | translate }}:</span>
      <div class="label-color" [class.red-500-bg]="location.archived" [class.green-500-bg]="!location.archived"></div>
      <span class="limit-cells" [matTooltip]="location.name" [matTooltipShowDelay]="500">
        {{ location.name }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="streetName">
    <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex>
      {{ 'LOCATIONS.HEADER.ADDRESS' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let location" fxFlex fxFlex.xs="100">
      <span class="mobile-label">{{ 'LOCATIONS.HEADER.ADDRESS' | translate }}:</span>
      <span class="limit-cells" [matTooltip]="location.address.formattedAddress" [matTooltipShowDelay]="500">
        {{ location.address | formatAddress }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="edit">
    <mat-header-cell *matHeaderCellDef fxFlex="7">
      {{ 'LOCATIONS.HEADER.ACTIONS' | translate }}
    </mat-header-cell>
    <mat-cell fxLayoutAlign.xs="center center" fxFlex="7" fxFlex.xs="100" *matCellDef="let location">
      <span class="mobile-label uppercase">{{ 'LOCATIONS.EDIT' | translate }}</span>
      <button
        mat-icon-button
        [matTooltip]="(hasEditLocationPermission ? 'LOCATIONS.EDIT' : 'LOCATIONS.VIEW') | translate"
        (click)="openDialog(location.id)"
      >
        <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit location" />
      </button>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="noData">
    <mat-footer-cell
      *matFooterCellDef
      [attr.colspan]="displayedColumns.length"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      {{ 'LOCATIONS.NO_DATA' | translate }}
    </mat-footer-cell>
  </ng-container>

  <ng-container matColumnDef="loading">
    <mat-footer-cell
      *matFooterCellDef
      [attr.colspan]="displayedColumns.length"
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <div class="p-24" fxLayout="column" fxLayoutAlign="center center">
        <mat-spinner color="primary" diameter="64" class="mb-24"></mat-spinner>
        {{ 'LOCATIONS.LOADING' | translate }}
      </div>
    </mat-footer-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || locations?.length"></mat-footer-row>
  <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading || locations?.length"></mat-footer-row>
</mat-table>
<mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
